"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-var-requires */
const react_1 = __importStar(require("react"));
const PreviewerContext_1 = __importDefault(require("../../PreviewerContext"));
const fontGlyphs = {
    material: require('../../iconGlyphmaps/material').default,
    FontAwesome: require('../../iconGlyphmaps/FontAwesome').default,
    Zocial: require('../../iconGlyphmaps/Zocial').default,
    AntDesign: require('../../iconGlyphmaps/AntDesign').default,
    Foundation: require('../../iconGlyphmaps/Foundation').default,
    Entypo: require('../../iconGlyphmaps/Entypo').default,
    EvilIcons: require('../../iconGlyphmaps/EvilIcons').default,
    Feather: require('../../iconGlyphmaps/Feather').default,
    Fontisto: require('../../iconGlyphmaps/Fontisto').default,
    Ionicons: require('../../iconGlyphmaps/Ionicons').default,
    MaterialCommunityIcons: require('../../iconGlyphmaps/MaterialCommunityIcons').default,
    Octicons: require('../../iconGlyphmaps/Octicons').default,
    SimpleLineIcons: require('../../iconGlyphmaps/SimpleLineIcons').default,
};
const FontIcon = ({ size, color, style, name, family, onPress, }) => {
    const { mapfontFamilyToFontName, Render, } = (0, react_1.useContext)(PreviewerContext_1.default);
    const selectedFontFamily = family || 'material';
    const internalStyle = (0, react_1.useMemo)(() => (Object.assign(Object.assign({ color, fontSize: size, fontFamily: mapfontFamilyToFontName(selectedFontFamily) }, style), { fontWeight: 'normal', fontStyle: 'normal' })), [color, size, selectedFontFamily, style, mapfontFamilyToFontName]);
    return (react_1.default.createElement(Render.Text, { style: internalStyle, onPress: onPress }, String.fromCharCode(fontGlyphs[selectedFontFamily][name])));
};
exports.default = FontIcon;
